import { render, staticRenderFns } from "./Plate.vue?vue&type=template&id=40b94060&scoped=true"
import script from "./Plate.vue?vue&type=script&lang=js"
export * from "./Plate.vue?vue&type=script&lang=js"
import style0 from "./Plate.vue?vue&type=style&index=0&id=40b94060&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b94060",
  null
  
)

export default component.exports